import script from "./SupportMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportMessages.vue?vue&type=script&setup=true&lang=js"

import "./SupportMessages.vue?vue&type=style&index=0&id=2d873ff4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d873ff4"]])

export default __exports__